import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  FormControl,
  FormHelperText,
  FormLabel,
  HStack,
  Input,
  Text,
  VStack,
} from '@chakra-ui/react';
import {
  hasIntervalloSquadre,
  isGiocoASquadre,
  MIN_SQUADRE_GIOCO,
} from '../../utils/manualeGiocoSquadre';

function ManualeGiocoSquadreField({
  numeroSquadre,
  onNumeroSquadreChange,
  numeroSquadreMax,
  onNumeroSquadreMaxChange,
}) {
  const giocoASquadre = isGiocoASquadre(numeroSquadre);
  const intervallo = hasIntervalloSquadre(numeroSquadre, numeroSquadreMax);
  const maxInvalido =
    giocoASquadre &&
    numeroSquadreMax !== '' &&
    Number(numeroSquadreMax) <= Number(numeroSquadre);

  const [finoAEnabled, setFinoAEnabled] = useState(
    () => numeroSquadreMax !== '' && numeroSquadreMax != null
  );

  useEffect(() => {
    if (numeroSquadreMax !== '' && numeroSquadreMax != null) {
      setFinoAEnabled(true);
    }
  }, [numeroSquadreMax]);

  const handleGiocoASquadreCheck = (e) => {
    const { checked } = e.target;
    if (checked) {
      onNumeroSquadreChange(
        giocoASquadre ? String(numeroSquadre) : String(MIN_SQUADRE_GIOCO)
      );
    } else {
      onNumeroSquadreChange('');
      onNumeroSquadreMaxChange('');
      setFinoAEnabled(false);
    }
  };

  const handleFinoACheck = (e) => {
    const { checked } = e.target;
    setFinoAEnabled(checked);
    if (!checked) {
      onNumeroSquadreMaxChange('');
    }
  };

  const maxHelperText = (() => {
    if (intervallo) {
      return `Il gioco si può giocare da ${numeroSquadre} a ${numeroSquadreMax} squadre.`;
    }
    if (maxInvalido) {
      return 'Il massimo deve essere maggiore del numero di squadre.';
    }
    return `Lascia vuoto se il numero di squadre è fisso; altrimenti indica il massimo (deve essere maggiore di ${numeroSquadre}).`;
  })();

  return (
    <VStack align="stretch" spacing={3} mt={4}>
      <Checkbox isChecked={giocoASquadre} onChange={handleGiocoASquadreCheck}>
        Questo gioco si gioca a squadre
      </Checkbox>
      {giocoASquadre ? (
        <>
          <FormControl>
            <FormLabel>Numero di squadre</FormLabel>
            <Input
              type="number"
              min={MIN_SQUADRE_GIOCO}
              step={1}
              inputMode="numeric"
              value={numeroSquadre}
              onChange={(e) => onNumeroSquadreChange(e.target.value)}
            />
            {!finoAEnabled ? (
              <FormHelperText>
                Il gioco prevede {numeroSquadre} squadre.
              </FormHelperText>
            ) : null}
          </FormControl>
          <Checkbox isChecked={finoAEnabled} onChange={handleFinoACheck}>
            Il gioco si può fare con un numero variabile di squadre, fino a
          </Checkbox>
          {finoAEnabled ? (
            <FormControl isInvalid={maxInvalido}>
              <HStack spacing={2} align="center">
                <Input
                  type="number"
                  min={Number(numeroSquadre) + 1 || MIN_SQUADRE_GIOCO + 1}
                  step={1}
                  inputMode="numeric"
                  placeholder="es. 4"
                  value={numeroSquadreMax}
                  onChange={(e) => onNumeroSquadreMaxChange(e.target.value)}
                  maxW="120px"
                />
                <Text fontSize="sm" color="gray.600">
                  squadre
                </Text>
              </HStack>
              <FormHelperText>{maxHelperText}</FormHelperText>
            </FormControl>
          ) : null}
        </>
      ) : null}
    </VStack>
  );
}

export default ManualeGiocoSquadreField;
